"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _capitalize = _interopRequireDefault(require("lodash/capitalize"));
var _styles = _interopRequireDefault(require("./styles.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Appdefs = window.cccisd.appDefs;
var Fortress = window.cccisd && window.cccisd.fortress;
var Results = /*#__PURE__*/function (_React$Component) {
  function Results() {
    var _this;
    _classCallCheck(this, Results);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Results, [].concat(args));
    _defineProperty(_this, "heartbeat", null);
    _defineProperty(_this, "heartbeatInterval", 300 * 1000);
    _defineProperty(_this, "startHeartbeat", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Reset front-end timer
            window.dispatchEvent(new CustomEvent('cccisd.ajax'));
            _this.heartbeat = setTimeout(_this.startHeartbeat, _this.heartbeatInterval);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    /**
     * Render a detail message with the provided data.
     * @param {string} title The messages's title
     * @param {string} resultNum The result this card is displaying
     * @param {string} resultRows The associated comma-separated rows
     * @param {string} className The className to use on the div
     * @return {Object}
     */
    _defineProperty(_this, "_renderDetails", function (title, resultNum, resultRows, className) {
      resultNum = Number.parseInt(resultNum, 10);
      var rowInfo = resultNum === 0 ? '' : " (Row".concat(resultNum === 1 ? '' : 's', ": ").concat(resultRows, ")");
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _styles["default"].summaryMessage
      }, title, ": ", resultNum), rowInfo);
    });
    return _this;
  }
  _inherits(Results, _React$Component);
  return _createClass(Results, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // If the job was cancelled, go back to dropzone
      if (!this.props.results.numTotal && !this.props.results.numErrors && !this.props.results.numErrorRows) {
        this.props.clearValidatedFile();
        return;
      }
      this.heartbeatInterval = Fortress.settings.config.auto_logout.heartbeatInterval * 1000;
      this.heartbeat = setTimeout(this.startHeartbeat, this.heartbeatInterval);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.heartbeat);
    }
  }, {
    key: "_flattenErrors",
    value:
    // HELPER METHODS /////////////////////////////////////////////////////////

    /**
     * Flatten the errors into an array of objects with keys for `errorRow`,
     * `errorType`, `errorMsg`, and `uniqueKey`.
     * @return {Object} Array keyed to expected columns
     */
    function _flattenErrors() {
      var ret = [];
      var results = this.props.results;
      if (!results.numErrors) {
        return ret;
      }

      // We now know that this exists...
      var errors = results.errors;

      // A comparitor function for sane numerical sorting of strings
      var compareNumbers = function compareNumbers(a, b) {
        return a - b;
      };
      var uniqueKey = 1;
      Object.keys(errors).sort(compareNumbers).forEach(function (rowKey) {
        // Go through each error key for this row
        Object.keys(errors[rowKey]).forEach(function (errorKey) {
          // Add an entry for each of its messages
          errors[rowKey][errorKey].forEach(function (errorMsg) {
            ret.push({
              errorRow: rowKey.match(/\d+$/)[0],
              errorType: errorKey,
              errorMsg: errorMsg,
              uniqueKey: uniqueKey
            });
            uniqueKey += 1;
          });
        });
      });
      return ret;
    }

    /**
     * Render the primary button with the proper text for the situation.
     * @return {Object} A button for the primary action.
     */
  }, {
    key: "_renderPrimaryButton",
    value: function _renderPrimaryButton() {
      var _this$props = this.props,
        clearValidatedFile = _this$props.clearValidatedFile,
        isPreflight = _this$props.isPreflight,
        results = _this$props.results,
        runExecute = _this$props.runExecute;

      // Defaults
      var buttonText = 'Start New Upload';
      var onClick = clearValidatedFile;
      var btnClass = 'btn-secondary';
      if (results.numErrors) {
        buttonText = 'Upload New File';
      } else if (isPreflight) {
        if (parseInt(results.numAdded, 10) === 0 && parseInt(results.numUpdated, 10) === 0 && parseInt(results.numRostered, 10) === 0) {
          buttonText = 'Upload New File';
        } else {
          onClick = runExecute;
          buttonText = 'Execute Changes';
          btnClass = 'btn-success';
        }
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn ".concat(btnClass),
        onClick: onClick
      }, buttonText);
    }

    /**
     * Render the secondary button with the proper text for the situation.
     * @return {Object|null} A button for the secondary action or null.
     */
  }, {
    key: "_renderSecondaryButton",
    value: function _renderSecondaryButton() {
      var _this$props2 = this.props,
        clearValidatedFile = _this$props2.clearValidatedFile,
        isPreflight = _this$props2.isPreflight,
        results = _this$props2.results;
      if (!isPreflight || isPreflight && results.numErrors) {
        return null;
      }
      if (parseInt(results.numAdded, 10) === 0 && parseInt(results.numUpdated, 10) === 0 && parseInt(results.numRostered, 10) === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary ".concat(_styles["default"].buttonSpacing),
        onClick: clearValidatedFile
      }, "Cancel and Upload New File");
    }

    /**
     * Render the appropriate status message.
     * @return {string}
     */
  }, {
    key: "_statusMessage",
    value: function _statusMessage() {
      var _this$props3 = this.props,
        isPreflight = _this$props3.isPreflight,
        results = _this$props3.results;
      var action = isPreflight ? 'Validation' : 'Execution of Changes';
      if (results.numErrors) {
        return /*#__PURE__*/_react["default"].createElement("span", null, action, " Failed: ", /*#__PURE__*/_react["default"].createElement("span", {
          className: "text-danger"
        }, results.numErrors, " Errors Found"));
      }
      return "".concat(action, " Completed Successfully");
    }

    /**
     * Render the appropriate status message.
     * @return {Object|null}
     */
  }, {
    key: "_summaryMessage",
    value: function _summaryMessage() {
      var _this$props4 = this.props,
        isPreflight = _this$props4.isPreflight,
        _this$props4$results = _this$props4.results,
        addedRows = _this$props4$results.addedRows,
        bulkType = _this$props4$results.bulkType,
        deploymentId = _this$props4$results.deploymentId,
        earlyExitRow = _this$props4$results.earlyExitRow,
        maxErrorsNum = _this$props4$results.maxErrorsNum,
        numAdded = _this$props4$results.numAdded,
        numErrorRows = _this$props4$results.numErrorRows,
        numErrors = _this$props4$results.numErrors,
        numReusedUsers = _this$props4$results.numReusedUsers,
        numReidentified = _this$props4$results.numReidentified,
        numRostered = _this$props4$results.numRostered,
        numTotal = _this$props4$results.numTotal,
        numUnchanged = _this$props4$results.numUnchanged,
        numUpdated = _this$props4$results.numUpdated,
        reusedUserRows = _this$props4$results.reusedUserRows,
        reidentifiedRows = _this$props4$results.reidentifiedRows,
        rosteredRows = _this$props4$results.rosteredRows,
        unchangedRows = _this$props4$results.unchangedRows,
        updatedRows = _this$props4$results.updatedRows;
      var reachedOrExceeded = numErrors > maxErrorsNum ? 'exceeded' : 'reached';
      var earlyExitMsg = numErrors < maxErrorsNum ? "Processing halted at row ".concat(earlyExitRow + 1, ", when an error was encountered.") : "Processing halted at row ".concat(earlyExitRow + 1, ", when max of ").concat(maxErrorsNum, " errors was ").concat(reachedOrExceeded, ".");
      var summaryMessage = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        className: _styles["default"].summaryMessage
      }, isPreflight ? 'Inspected' : 'Processed', " ", earlyExitRow ? earlyExitRow + ' of ' : '', " ", numTotal, ' ', bulkType, !numErrorRows ? '' : " (".concat(numErrorRows, " with errors)"), "."), !earlyExitRow ? null : /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-danger"
      }, earlyExitMsg));

      // Try to match to label and labelPlural from Appdefs
      var entityTypePlural;
      var entityTypeSingular;
      try {
        var allEntityDefs = [].concat(_toConsumableArray(Appdefs.pawn.groups), _toConsumableArray(Appdefs.pawn.roles));
        var entityDef = allEntityDefs.find(function (def) {
          return [def.label, def.labelPlural].includes(bulkType);
        });
        if (entityDef && entityDef.label && entityDef.labelPlural) {
          entityTypePlural = entityDef.labelPlural;
          entityTypeSingular = entityDef.label;
        }
      } catch (e) {
        // meh, handle it below
      }

      // If you can't match from Appdefs, just use bulkType
      if (!entityTypePlural) {
        entityTypePlural = bulkType;
        if (bulkType[0] !== bulkType[0].toUpperCase()) {
          entityTypePlural = (0, _capitalize["default"])(bulkType);
        }
      }
      if (!entityTypeSingular) {
        // This is imperfect! Assumes that there is just an extra 's' or 'ies'
        entityTypeSingular = entityTypePlural;
        entityTypeSingular = entityTypePlural.substring(0, entityTypePlural.length - 1);
        if (entityTypePlural.endsWith('ies')) {
          entityTypeSingular = entityTypePlural.substring(0, entityTypePlural.length - 3) + 'y';
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, summaryMessage, numErrors ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _styles["default"].summaryContainer
      }, this._renderResultCard("".concat(entityTypePlural, " ").concat(isPreflight ? 'to Add' : 'Added'), numAdded), this._renderResultCard("".concat(entityTypePlural, " ").concat(isPreflight ? 'to Update' : 'Updated'), numUpdated), this._renderResultCard("Unchanged ".concat(entityTypePlural), numUnchanged), deploymentId && this._renderResultCard("".concat(entityTypePlural, " ").concat(isPreflight ? 'to Add' : 'Added', " to Data Collection Wave"), numRostered)), numReusedUsers > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: _styles["default"].detailArea
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _styles["default"].summaryMessage
      }, numReusedUsers === 1 ? "There ".concat(isPreflight ? 'will be' : 'was', " ").concat(numReusedUsers, " ").concat(entityTypeSingular, " added to an existing User account.") : "There ".concat(isPreflight ? 'will be' : 'were', " ").concat(numReusedUsers, " ").concat(entityTypePlural, " added to existing User accounts.")), ' ', "(Row", numReusedUsers === 1 ? '' : 's', " in file: ", reusedUserRows, ")"), numReidentified > 0 && /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-danger ".concat(_styles["default"].detailArea)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _styles["default"].summaryMessage
      }, /*#__PURE__*/_react["default"].createElement("b", null, numReidentified === 1 ? "There was 1 ".concat(entityTypeSingular, " that appeared on multiple rows.") : "There were ".concat(numReidentified, " ").concat(entityTypePlural, " that appeared on multiple rows."))), ' ', "(Duplicate row", numReidentified === 1 ? '' : 's', " in file: ", reidentifiedRows, ")"), /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
        title: "Details"
      }, this._renderDetails("".concat(entityTypePlural, " ").concat(isPreflight ? 'to Add' : 'Added'), numAdded, addedRows, ''), this._renderDetails("".concat(entityTypePlural, " ").concat(isPreflight ? 'to Update' : 'Updated'), numUpdated, updatedRows, _styles["default"].detailArea), this._renderDetails("Unchanged ".concat(entityTypePlural), numUnchanged, unchangedRows, _styles["default"].detailArea), deploymentId && this._renderDetails("".concat(entityTypePlural, " ").concat(isPreflight ? 'to Add' : 'Added', " to Data Collection Wave"), numRostered, rosteredRows, _styles["default"].detailArea))));
    }
  }, {
    key: "_renderResultCard",
    value:
    /**
     * Render a result card with the provided data.
     * @param {string} title The card's title
     * @param {string} resultNum The result this card is displaying
     * @return {Object}
     */
    function _renderResultCard(title, resultNum) {
      var isPreflight = this.props.isPreflight;
      var bannerText = isPreflight ? 'Preflight Validation' : 'Executed Successfully';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _styles["default"].summaryCard
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: (isPreflight ? 'bg-info text-info ' : 'bg-success text-success ') + _styles["default"].cardBanner
      }, bannerText), /*#__PURE__*/_react["default"].createElement("p", {
        className: _styles["default"].summaryTitle
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: (isPreflight ? 'text-info ' : 'text-success ') + _styles["default"].summaryCount
      }, resultNum));
    }
  }, {
    key: "render",
    value: function render() {
      var numErrors = this.props.results.numErrors;
      // Define columns and data for table
      var _columns = [{
        name: 'errorRow',
        label: 'Row'
      }, {
        name: 'errorType',
        label: 'Column'
      }, {
        name: 'errorMsg',
        label: 'Error Message'
      }];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "clearfix"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
        className: _styles["default"].summaryTitle
      }, this._statusMessage()), this._summaryMessage(), !numErrors ? null : /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        className: "table table-striped",
        columns: _columns,
        data: this._flattenErrors(),
        hideShowingRowsSummary: true,
        rowKey: "uniqueKey",
        showPerPageOptions: numErrors > 50
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "float-end ".concat(_styles["default"].verticalSpacing)
      }, this._renderSecondaryButton(), this._renderPrimaryButton()));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Results, "propTypes", {
  /** Clear validated file from parent. */
  clearValidatedFile: _propTypes["default"].func.isRequired,
  /** Are we displaying preflight results? */
  isPreflight: _propTypes["default"].bool,
  /** The results to display */
  results: _propTypes["default"].object.isRequired,
  /** Submit (successfully preflighted) file to back end for execution. */
  runExecute: _propTypes["default"].func
});
_defineProperty(Results, "defaultProps", {
  runExecute: function runExecute() {}
});
var _default = exports["default"] = Results;